import { NormalizedCalendarEvent } from "./hooks/use-normalized-events";

export const SINGLE_DAY_DATE_FORMAT = "YYYY-MM-DD";

type EmptySlot = {
  type: "EMPTY";
  key: string;
};

type ShortEventSlot = {
  type: "SHORT_EVENT";
  event: NormalizedCalendarEvent;
  key: string;
};

type EventStartSlot = {
  type: "EVENT_START";
  event: NormalizedCalendarEvent;
  daySpan: number;
  key: string;
};

type EventContinuedSlot = {
  type: "EVENT_CONTINUED";
  key: string;
};

export type MonthlyViewEventSlot =
  | EmptySlot
  | ShortEventSlot
  | EventStartSlot
  | EventContinuedSlot;

export interface MonthlyViewDay {
  startISO: string;
  endISO: string;
  slots: MonthlyViewEventSlot[];
}

export type MonthlyViewWeek = MonthlyViewDay[];
